import { motion } from 'framer-motion';

interface Partner {
  src: string;
  alt: string;
  href: string;
}

// Lista de parceiros
const partners: Partner[] = [
  {
    src: '/images/partners/partner-1.webp',
    alt: 'Exata Imobiliária',
    href: 'https://exataimobiliaria.com.br/',
  },
  {
    src: '/images/partners/partner-22.webp',
    alt: 'CPM Construtora',
    href: 'https://cpmconstrutora.com',
  },
  {
    src: '/images/partners/partner-3.webp',
    alt: 'Comunidade Cristã Terras de Sião',
    href: 'https://terrasdesiao.com/'
  }
];

export default function Partners() {
  return (
    <section id="partners" className="py-16 bg-gray-50 dark:bg-dark-secondary">
      <div className="container mx-auto px-4">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="text-center mb-12"
        >
          <h2 className="text-3xl font-bold text-gray-900 dark:text-white mb-4">
            Nossos Parceiros
          </h2>
          <div className="w-20 h-1 bg-primary-500 mx-auto"></div>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 lg:gap-16 justify-items-center px-4 md:px-8 lg:px-12">
          {partners.map((partner, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: index * 0.1 }}
              whileHover={{ scale: 1.05 }}
              className="w-full max-w-sm"
            >
              <a
                href={partner.href}
                target="_blank"
                rel="noopener noreferrer"
                className="block bg-white dark:bg-brand-secondary rounded-xl shadow-lg overflow-hidden hover:shadow-xl transition-all duration-300 h-full flex flex-col"
              >
                <div className="flex-1 flex items-center justify-center p-6 bg-white dark:bg-brand-primary min-h-[200px] lg:min-h-[250px]">
                  <img
                    src={partner.src}
                    alt={partner.alt}
                    className="w-full h-full object-contain p-2"
                    style={{ objectFit: 'contain', maxHeight: '100%', maxWidth: '100%' }}
                  />
                </div>
                <div className="p-4 bg-brand-primary hover:bg-brand-secondary/90 text-center border-t border-gray-200 dark:border-brand-accent/30 transition-colors duration-300">
                  <h3 className="text-lg font-medium text-white">
                    {partner.alt}
                  </h3>
                </div>
              </a>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
